import { Calendar } from "./calendar.model";

export class CalendarEventResult {
    public calendarEvents: Calendar[];
    public totalRecords: number;
}



// WEBPACK FOOTER //
// D:/a/1/s/Uhm.Loops.Web/src/app/calendar/calendar-event-result.model.ts